// app/(routes)/tools/ai-for-financial-advisors/workflow-finder.analytics.ts
// Visitor identity + report event helpers shared by the tool wizard and the
// report view. Analytics must never block a useful report or its controls.
export const WORKFLOW_FINDER_API = "/api/tools/advisor-ai-workflow-finder";

export function getStoredId(key: string): string {
  const existing = window.localStorage.getItem(key);
  if (existing) return existing;
  const value = crypto.randomUUID();
  window.localStorage.setItem(key, value);
  return value;
}

export function getBrowserSessionId(): string {
  const key = "htf_workflow_finder_browser_session";
  const existing = window.sessionStorage.getItem(key);
  if (existing) return existing;
  const value = crypto.randomUUID();
  window.sessionStorage.setItem(key, value);
  return value;
}

export async function recordReportEvent(
  shareSlug: string,
  eventType: "report_view" | "report_share" | "report_cta_click",
  options: {
    eventId: string;
    metadata?: Record<string, string>;
  },
) {
  try {
    await fetch(
      `${WORKFLOW_FINDER_API}/reports/${encodeURIComponent(shareSlug)}/events`,
      {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          event_type: eventType,
          visitor_id: getStoredId("htf_anon_id"),
          browser_session_id: getBrowserSessionId(),
          event_id: options.eventId,
          referrer: document.referrer || undefined,
          metadata: options.metadata || {},
        }),
        keepalive: true,
      },
    );
  } catch {
    // Analytics must not block a useful report or its sharing controls.
  }
}
